module.exports = __webpack_public_path__ + "static/media/VidgoSportscenter.b1e2bdbe.png";